import React from 'react';
import * as columnTypes from 'const/columnTypes';
import * as roleConst from 'auth/roleConst';
import GoogleSheetSVG from 'assets/images/svg/GoogleSheetSVG';
import MySqlSVG from 'assets/images/svg/MySqlSVG';
import PostgresSVG from 'assets/images/svg/PostgresSVG';
import i18n from 'i18n';

export const HEADER_HEIGHT = 60;
export const LAYOUT_CONTENT_HEADER = 88;
export const HEADER_RECORD_HISTORY_HEIGHT = 60;
export const DRAWER_WIDTH = 240;
export const DASHBOARD = 'DASHBOARD';
export const GRID_UI = 'GRID_UI';
export const WORKSPACE_SETTING = 'WORKSPACE_SETTING';
export const VERSION_CONTROL = 'VERSION_CONTROL';
export const ADVANCED_SEARCH = 'ADVANCED_SEARCH';

export const HEIGHT_UNICORN = 200;
export const HEIGHT_FAVORITE_LIST_GRID = 210;

export const SIDEBAR_RIGHT_WIDTH = 450;

export const SCROLLBAR_RELEASE_TIME = 50;
export const SIDE_BAR_ADVANCED_SEARCH_WIDTH_ON = 256;
export const SIDE_BAR_ADVANCED_SEARCH_WIDTH_OFF = 32;

/**
 * PERMISSION PAGES
 */
export const PERMISSION_SETTING = 'PERMISSION_SETTING';
export const COMPANY_INFO = 'COMPANY_INFO';
export const MEMBERS = 'MEMBERS';
export const GROUPS = 'GROUPS';
export const PAYMENT = 'PAYMENT';
export const ROLES = 'ROLES';

export const PROFILE_SETTING = 'PROFILE_SETTING';
export const TM_PREFIX = '_tm_';
export const GRID_UPLOAD_SUPPORTED_EXTENSIONS = ['.csv', '.xls', '.xlsx', '.CSV', '.XLS', '.XLSX', '.tsv'];
export const GRID_UPLOAD_LOCALIZATION_SUPPORTED_EXTENSIONS = [
    '.csv',
    '.xls',
    '.xlsx',
    '.json',
    '.CSV',
    '.XLS',
    '.XLSX',
    '.JSON',
    '.po',
    '.tsv'
];
export const GRID_FILESTACK_UPLOAD_SUPPORTED_EXTENDSIONS = ['.csv', '.xls', '.xlsx', '.CSV', '.XLS', '.XLSX'];
export const TM_UPLOAD_SUPPORTED_EXTENSIONS = ['.tmx', '.csv', '.xls', '.xlsx'];
export const TB_UPLOAD_SUPPORTED_EXTENSIONS = ['.tbx', '.csv', '.xls', '.xlsx'];

const oneMB = 1024 * 1024;
export const oneGB = oneMB * 1024;

export const GRID_UPLOAD_MAX_SIZE = 200 * oneMB;
export const IMAGE_EXTENSIONS = [
    '.jpg',
    '.jpeg',
    '.exif',
    '.tiff',
    '.gif',
    '.bmp',
    '.png',
    '.webp',
    '.svg',
    '.JPG',
    '.JPEG',
    '.EXIF',
    '.TIFF',
    '.GIF',
    '.BMP',
    '.PNG',
    '.WEBP',
    '.SVG'
];
export const AUDIO_EXTENSIONS = [
    '.wav',
    '.mp3',
    '.vox',
    '.wma',
    '.3gp',
    '.ogg',
    '.mogg',
    '.WAV',
    '.MP3',
    '.VOX',
    '.WMA',
    '.3GP',
    '.OGG',
    '.MOGG'
];
export const VIDEO_EXTENSIONS = [
    '.flv',
    '.webm',
    '.vob',
    '.avi',
    '.wmv',
    '.mp4',
    '.mov',
    '.FLV',
    '.WEBM',
    '.VOB',
    '.AVI',
    '.WMV',
    '.MP4',
    '.MOV'
];
export const AVATAR_EXTENSIONS = ['.jpg', '.jpeg', '.gif', '.png', '.JPG', '.JPEG', '.GIF', '.PNG'];
export const UPDATE_COLUMN_META = 'UPDATE_COLUMN_META';
export const SWITCH_COLUMN_TYPE = 'SWITCH_COLUMN_TYPE';
export const EXPORT_LOCALIZATION_EXTENSIONS = ['.xls', '.xlsx', '.XLS', '.XLSX'];
export const EXPORT_LOCALIZATION_JSON_EXTENSIONS = ['.json', '.JSON'];
export const EXPORT_LOCALIZATION_PO_EXTENSIONS = ['.po', '.PO'];

export const COLORING = 'COLORING';

export const DEFAULT_ROLE_USER = {
    id: 3,
    name: 'User',
    isSystemRole: true
};
export const DEFAULT_ROLE_ADMIN = {
    id: 2,
    name: 'Admin',
    isSystemRole: true
};

export const DEFAULT_ROLE_OWNER = {
    id: 1,
    name: 'Owner',
    isSystemRole: true
};

export const DEFAULT_PROJECT_ROLE_VIEWER = {
    id: 6,
    name: roleConst.VIEWER
};

export const DEFAULT_PROJECT_ROLE_EDITOR = {
    id: 5,
    name: roleConst.EDITOR
};

// RIGHT SIDEBAR TYPES
export const WORKSPACE_DETAILS = 'WORKSPACE_DETAILS';
export const WORKSPACE_ABOUT = 'WORKSPACE_ABOUT';
export const WORKSPACE_GROUP_MEMBER = 'WORKSPACE_GROUP_MEMBER';
export const DATABASE_BACKUP = 'DATABASE_BACKUP';
export const USAGE_STATISTIC = 'USAGE_STATISTIC';

// USER STATES
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const PENDING_INVITE = 'PENDING_INVITE';
export const PENDING_APPROVAL = 'PENDING_APPROVAL';

// MEMBER TABS
export const COMPANY_MEMBERS = 'Company members';
export const INTERNAL_MEMBERS = 'LD internal members';

// PAYMENT
export const PLAN_TYPES = {
    FREE: 'FREE',
    LITE: 'LITE',
    ESSENTIAL: 'ESSENTIAL',
    PROFESSIONAL: 'PROFESSIONAL',
    ENTERPRISE: 'ENTERPRISE',
    MEM_SOURCE: 'MEM_SOURCE',
    MEMO_Q: 'MEMO_Q',
    AUTO_QA: 'AUTO_QA',
    LAMBDA: 'LAMBDA'
};

export const COMPANY_BUSINESS_TYPES = {
    NA: 'NA',
    INTERNAL: 'INTERNAL',
    TRANSLATION: 'TRANSLATION',
    ENTERPRISE: 'ENTERPRISE'
};

export const PLAN_LEVEL = {
    [PLAN_TYPES.FREE]: 1,
    [PLAN_TYPES.LITE]: 2,
    [PLAN_TYPES.ESSENTIAL]: 3,
    [PLAN_TYPES.PROFESSIONAL]: 4,
    [PLAN_TYPES.ENTERPRISE]: 5
};

export const SEAT_PRICE = 29;
export const MAX_SEAT_INPUT = 10000;

export const PLAN_CYCLE = {
    month: 'month',
    year: 'year'
};

export const PAYMENT_METHODS = {
    STRIPE: 'STRIPE',
    INVOICE: 'INVOICE'
};

export const PAYMENT_WARNING_TYPES = {
    INFO: 'INFO',
    ERROR: 'ERROR'
};

export const PAYMENT_CARD_TYPES = {
    VISA: 'VISA',
    MASTER: 'MASTERCARD',
    JCB: 'JCB',
    DISCOVER: 'DISCOVER',
    AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
    DINNERS_CLUB: 'DINNERS_CLUB',
    UNION_PAY: 'UNION_PAY'
};

export const SUBSCRIPTION_STATUS = {
    ACTIVE: 'ACTIVE',
    TRIALING: 'TRIALING'
};

export const USAGE_PROPERTIES = {
    GRIDS_PER_PROJECT: 'gridsPerProject',
    LOCALES_PER_PROJECT: 'localesPerProject',
    RECORDS_IN_PROJECT: 'recordsInProject',
    STORAGE_GB: 'storageGb',
    VERSION_CONTROL_ENVIROMENT_PER_PROJECT: 'versionControlEnvironmentPerProject',
    TM_PER_COMPANY: 'tmPerCompany',
    BRANCH_RECORDS_PER_COMPANY: 'branchRecordsPerCompany',

    //company changes
    BACK_UP_RETENTION_BY_DAYS: 'backupRetentionByDays',
    BRANCH_LIMIT_X: 'branchLimitX',
    CUSTOM_USER_ROLE: 'customUserRole',
    DATA_ACCESS_CONTROL: 'dataAccessControl',
    MAX_API_REQUESTS_PER_MONTH: 'maxApiRequestsPerMonth',
    MAX_LOCALES: 'maxLocales',
    MAX_RECORD: 'maxRecord',
    MAX_STORAGE_GB: 'maxStorageGb',
    REVISION_HISTORY_BY_MONTHS: `revisionHistoryByMonths`,
    SLA: 'sla',
    TRANSLATION_MEMORY: `translationMemory`,
    FREE_USERS: `freeUsers`,
    BRANCH_PER_COMPANY: 'branchPerCompany',
    GRID_PER_COMPANY: 'gridPerCompany',
    PROJECT_PER_COMPANY: 'projectPerCompany',
    TM_UNIT_PER_COMPANY: 'tmUnitPerCompany',
    USER_PER_COMPANY: 'userPerCompany',
    VERSION_CONTROL: 'versionControl',
    VIEW_GROUP_SHARE: 'viewGroupShare',
    TRANSLATION_IMPORT_EXPORT: 'translationImportExport',
    CUSTOM_GROUP: 'customGroup'
};

export const TRANSLATION_IMPORT_EXPORT_OPTIONS = {
    YES: 'YES',
    NO: 'NO',
    LIMITED: 'LIMITED'
};

export const MAP_DATA_COLLECTOR_PROPERTIES_TO_PAYMENT_PROPERTIES = {
    totalBranch: USAGE_PROPERTIES.BRANCH_PER_COMPANY,
    totalGrid: USAGE_PROPERTIES.GRID_PER_COMPANY,
    totalProject: USAGE_PROPERTIES.PROJECT_PER_COMPANY,
    totalRecord: USAGE_PROPERTIES.MAX_RECORD,
    totalStorageGb: USAGE_PROPERTIES.MAX_STORAGE_GB,
    totalTmUnit: USAGE_PROPERTIES.TM_UNIT_PER_COMPANY,
    totalUser: USAGE_PROPERTIES.USER_PER_COMPANY,
    totalBranchRecord: USAGE_PROPERTIES.BRANCH_RECORDS_PER_COMPANY,
    totalApiRequest: USAGE_PROPERTIES.MAX_API_REQUESTS_PER_MONTH,
    biggestRecordCount: 'biggestRecordCount'
};

export const TEXT_COMPONENTS = [
    columnTypes.SINGLE_LINE,
    columnTypes.MULTIPLE_LINES,
    columnTypes.NUMBER,
    columnTypes.RICH_TEXT,
    columnTypes.MARKDOWN,
    columnTypes.TRANSLATION,
    columnTypes.YAML,
    columnTypes.RECORD_ID
];

export const EDITOR_COMPONENTS = [columnTypes.JSON_LD, columnTypes.HTML];

export const SELECTION_COMPONENTS = [columnTypes.SINGLE_SELECTION, columnTypes.MULTIPLE_SELECTIONS];

export const SUPPORT_TEXT_WRAPPING_COMPONENTS = [
    columnTypes.SINGLE_LINE,
    columnTypes.MULTIPLE_LINES,
    columnTypes.NUMBER,
    columnTypes.RICH_TEXT,
    columnTypes.MARKDOWN,
    columnTypes.TRANSLATION,
    columnTypes.JSON_LD,
    columnTypes.HTML,
    columnTypes.YAML,
    columnTypes.RECORD_ID,
    columnTypes.PATH_TAG,
    columnTypes.SINGLE_SELECTION,
    columnTypes.MULTIPLE_SELECTIONS,
    columnTypes.FILES
    // columnTypes.REFERENCE,
];

export const PATH_TAG_ID = '_pathTag';

export const PATH_TAG_MATCHES_ID = ['_pathTag', 'Path Tag', 'Path'];

export const LOCALIZATION_TYPES = {
    MULTIPLE: 'Multiple',
    SINGLE: 'Single'
};

export const DRAG_ITEM_TYPES = {
    ROW: 'ROW'
};

export const DROP_ITEM_TYPES = {
    PATH_TAG: 'PATH_TAG',
    RECORD: 'RECORD'
};

export const IMPORT_OPTIONS = {
    ADD: 'add',
    UPDATE_ONLY: 'updateOnly',
    ADD_AND_UPDATE: 'update'
};

export const SYSTEM_COLUMNS = [
    {
        defaultValue: '',
        id: PATH_TAG_ID,
        name: 'Path',
        type: columnTypes.PATH_TAG,
        version: 1,
        show: true
    },
    {
        defaultValue: '',
        id: columnTypes.ALTERED_BY,
        name: 'Last modified by',
        type: columnTypes.ALTERED_BY,
        version: 1,
        show: true
    },
    {
        defaultValue: '',
        id: columnTypes.ALTERED_TIME,
        type: columnTypes.ALTERED_TIME,
        name: 'Last modified time',
        version: 1,
        show: true
    },
    {
        defaultValue: '',
        id: columnTypes.CREATED_TIME,
        type: columnTypes.CREATED_TIME,
        name: 'Created time',
        version: 1,
        show: true
    },
    {
        defaultValue: '',
        id: columnTypes.CREATED_BY,
        type: columnTypes.CREATED_BY,
        name: 'Created by',
        version: 1,
        show: true
    },
    {
        defaultValue: '',
        id: columnTypes.RECORD_ID,
        name: 'Record ID',
        type: columnTypes.RECORD_ID,
        version: 1,
        show: true
    }
];

export const SYSTEM_COLUMN_IDS = [
    PATH_TAG_ID,
    columnTypes.CREATED_BY,
    columnTypes.CREATED_TIME,
    columnTypes.ALTERED_TIME,
    columnTypes.ALTERED_BY,
    columnTypes.RECORD_ID
];

export const SYSTEM_COLUMN_IDS_WITHOUT_PATH_TAG = [
    columnTypes.ALTERED_TIME,
    columnTypes.ALTERED_BY,
    columnTypes.RECORD_ID,
    columnTypes.CREATED_BY,
    columnTypes.CREATED_TIME
];

export const DISABLED_REFERENCE_COLUMN_TYPES = [
    columnTypes.JSON_LD,
    columnTypes.HTML,
    columnTypes.YAML,
    columnTypes.RICH_TEXT,
    columnTypes.MARKDOWN,
    columnTypes.REFERENCE
];

export const DISABLED_COLUMN_BY_TYPES = [columnTypes.FORMULA];

export const MERGE_RECORD_OPTIONS = {
    UPDATE: 'update',
    UPDATE_ONLY: 'updateOnly',
    ADD: 'add',
    OVERRIDE: 'override'
};

//DATABASE STATUS
export const DATABASE_STATUS = {
    ACTIVE: 'active',
    DELETED: 'deleted',
    IN_PROGRESS: 'in_progress',
    RUNNING: 'running',
    RESTORING: 'restoring',
    BACKING_UP: 'backing_up',
    FAILED: 'failed',
    SUCCESS: 'success',
    DUPLICATING: 'duplicating'
};
export const DEFAULT_AGGREGATION_TYPE = 'empty';
export const AGGREGATIONS_VALUE_TO_LABEL = {
    empty: i18n.t('global_empty'),
    filled: i18n.t('global_filled'),
    percentEmpty: i18n.t('percent_empty'),
    percentFilled: i18n.t('percent_filled'),
    percentUnique: i18n.t('percent_unique'),
    unique: i18n.t('global_unique'),
    earliest: i18n.t('earliest'),
    latest: i18n.t('latest'),
    sum: i18n.t('sum'),
    min: i18n.t('min'),
    max: i18n.t('max'),
    none: i18n.t('none'),
    wordCount: i18n.t('word_count')
};

export const AGGREGATIONS_VALUES = {
    empty: 'empty',
    filled: 'filled',
    percentEmpty: 'percentEmpty',
    percentFilled: 'percentFilled',
    percentUnique: 'percentUnique',
    unique: 'unique',
    earliest: 'earliest',
    latest: 'latest',
    sum: 'sum',
    min: 'min',
    max: 'max',
    none: 'none',
    wordCount: 'wordCount',
    conflict: 'conflicted'
};

export const AGGREGATIONS = {
    [columnTypes.SINGLE_LINE]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.MULTIPLE_LINES]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.RICH_TEXT]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.MARKDOWN]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.BOOLEAN]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' }
    ],
    [columnTypes.DATETIME]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' },
        { label: i18n.t('earliest'), value: 'earliest' },
        { label: i18n.t('global_latest'), value: 'latest' }
    ],
    [columnTypes.SINGLE_SELECTION]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.MULTIPLE_SELECTIONS]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.GROUP_TAGS]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.NUMBER]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' },
        { label: i18n.t('sum'), value: 'sum' },
        { label: i18n.t('min'), value: 'min' },
        { label: i18n.t('max'), value: 'max' }
    ],
    [columnTypes.FILES]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' }
    ],
    [columnTypes.REFERENCE]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.LOCALIZATION]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.FORMULA]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.TRANSLATION]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' },
        { label: i18n.t('word_count'), value: 'wordCount' }
    ],
    [columnTypes.JSON_LD]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.HTML]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ],
    [columnTypes.YAML]: [
        { label: i18n.t('global_empty'), value: 'empty' },
        { label: i18n.t('global_filled'), value: 'filled' },
        { label: i18n.t('global_unique'), value: 'unique' },
        { label: i18n.t('percent_empty'), value: 'percentEmpty' },
        { label: i18n.t('percent_filled'), value: 'percentFilled' },
        { label: i18n.t('percent_unique'), value: 'percentUnique' }
    ]
};

export const AGGREGATIONS_DISABLED_COLUMNS = [
    columnTypes.REFERENCE,
    columnTypes.PATH_TAG,
    columnTypes.CREATED_BY,
    columnTypes.CREATED_TIME,
    columnTypes.ALTERED_BY,
    columnTypes.ALTERED_TIME,
    columnTypes.RECORD_ID,
    columnTypes.FORMULA
];

export const WEB_HOOK_EXTERNAL_SYSTEMS = {
    BITBUCKET: `bitbucket`,
    SLACK: `SLACK`,
    REQUEST: `REQUEST`,
    LAMBDA: 'LAMBDA',
    HTTP: 'HTTP',
    GOOGLE_TRANSLATE: 'GOOGLE_TRANSLATE',
    AMAZON_TRANSLATE: 'AMAZON_TRANSLATE',
    AMAZON_TEXT_TO_SPEECH: 'AMAZON_TEXT_TO_SPEECH',
    AMAZON_TEXT_TO_SPEECH_NEURAL: 'AMAZON_TEXT_TO_SPEECH_NEURAL',
    AMAZON_COMPREHEND: 'AMAZON_COMPREHEND',
    JIRA: 'JIRA',
    GOOGLE_OCR: 'GOOGLE_OCR',
    CONDITION: 'CONDITION',
    SET: 'SET'
};

export const DEFAULT_EXTERNAL_SYSTEM = WEB_HOOK_EXTERNAL_SYSTEMS.WEB;
export const PERMISSION_EDIT_DISABLED = [roleConst.VIEWER];

export const GROUP_ADMIN_TYPES = {
    NORMAL: 'NORMAL',
    ADMIN: `ADMIN`
};

export const FEEDBACK_TYPES = {
    REPORT_A_BUG: 'REPORT_A_BUG',
    LEAVE_A_COMMEND: 'LEAVE_A_COMMEND',
    ASK_A_QUESTION: 'ASK_A_QUESTION',
    SUGGESS_AN_IMPROVEMENT: 'SUGGESS_AN_IMPROVEMENT'
};

export const DUPLICATE_RECORD_OPTIONS = {
    INCLUDE: 'include',
    EXCLUDE: 'exclude'
};

export const DELIMITER_OPTIONS = [
    { label: 'Comma ( , )', value: ',' },
    { label: 'Semicolon ( ; )', value: ';' },
    { label: 'Tilde ( ~ )', value: '~' },
    { label: 'Tab', value: '\t' }
];

export const API_KEY_TYPES = {
    FULL: 'FULL',
    RESTRICTED: 'RESTRICTED',
    READONLY: 'READ_ONLY'
};

export const API_KEY_STATUS = {
    ACTIVE: 'active',
    REVOKED: 'revoked'
};

export const ADD_ON_STATES = {
    DRAFT: 'DRAFT',
    DELETED: 'DELETED',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
};

export const MEMSOURCE_CONNECT_URL = `https://cloud.memsource.com/web/oauth/authorize?response_type=code&client_id=`;
export const MEMSOURCE_SETUP_URL = `https://cloud.memsource.com/web/oauthClient/list`;

export const ADDITIONAL_INFORMATION = 'additional information';
export const CHARACTER_LIMIT = 'character limit';

export const RECORD_IDS_MATCHES = [
    'id',
    'string identifier',
    'identifier',
    'recordId',
    '_recordId',
    'record id',
    'stringId',
    'string id',
    'string_id',
    '_publicRecordId',
    'publicRecordId',
    'public record id',
    '::ID::',
    'key',
    'keys'
];

export const PATH_TAG_IDS = ['_pathTag', 'pathTag', '_path', 'path'];

export const UPLOAD_SETUP_VIEW_TYPES = {
    TABLE: 'table',
    LIST: 'list'
};

export const COLUMN_GROUP_SECTIONS = {
    SPECIAL: 'SPECIAL',
    BASIC: 'BASIC',
    CODE_FORMATTING: 'CODE FORMATTING',
    ADD_ONS: 'ADD-ONS',
    SYSTEM_COLUMNS: 'SYSTEM COLUMNS'
};

export const IMPORT_VALID_COLUMN_TYPES = [
    columnTypes.SINGLE_LINE,
    columnTypes.MULTIPLE_LINES,
    columnTypes.BOOLEAN,
    columnTypes.DATETIME,
    columnTypes.NUMBER,
    columnTypes.RICH_TEXT,
    columnTypes.MARKDOWN,
    columnTypes.PATH_TAG,
    columnTypes.MARKDOWN,
    columnTypes.RECORD_ID,
    columnTypes.JSON_LD,
    columnTypes.HTML,
    columnTypes.YAML,
    columnTypes.SINGLE_SELECTION,
    columnTypes.MULTIPLE_SELECTIONS
];

export const IMPORT_WARNING_COLUMN_TYPES = [columnTypes.FILES, columnTypes.REFERENCE];
export const IMPORT_INSIDE_WARNING_COLUMN_TYPES = [columnTypes.FILES];

export const ALL_LANGUAGES = 'all';
export const DASHBOARD_TUTORIAL = 'DASHBOARD_TUTORIAL';
export const DASHBOARD_TUTORIAL_FROM_SIGNUP = 'DASHBOARD_TUTORIAL_FROM_SIGNUP';
export const GRID_TUTORIAL = 'GRID_TUTORIAL';

export const USER_SETTINGS = {
    BLINDNESS_DEPENDENCY: 'BLIND_NESS_DEPENDENCY',
    BLINDNESS_FILL_COLOR: 'BLINDNESS_FILL_COLOR',
    OPEN_ADD_ON: 'OPEN_ADD_ON',
    TEMPLATE_VIEW_TIME: 'TEMPLATE_VIEW_TIME',
    FINISH_DASHBOARD_TUTORIAL: 'FINISH_DASHBOARD_TUTORIAL',
    FINISH_GRID_TUTORIAL: 'FINISH_GRID_TUTORIAL',
    TRIAL_BACK_VIEW_TIME: 'TRIAL_BACK_VIEW_TIME',
    OPEN_PATH_TAG: 'openPathTag',
    GRID: {
        OPEN_PATH_TAG: 'openPathTag',
        RECORD_HISTORY_HEIGHT: `RECORD_HISTORY_HEIGHT`,
        OPEN_EXTEND_VIEW: `openExtendView`,
        EXTEND_VIEW_TYPE: `extendViewType`
    },
    VIEW: {
        DEFAULT_ROW_HEIGHT: 'defaultRowHeight',
        AUTO_QA: 'autoQA',
        MEMO_Q: `memoQ`,
        MEM_SOURCE: `MemSource`
    },
    SHOWN_PROMOTE_FEATURES: 'SHOWN_PROMOTE_FEATURES',
    NOTIFICATION_CENTER_READ_STATE: 'NOTIFICATION_CENTER_READ_STATE',
    AUTH_DISPLAY_NOTIFICATION_REALTIME: 'AUTH_DISPLAY_NOTIFICATION_REALTIME'
};

export const RESOURCE_TYPES = {
    GRID: 'GRID',
    VIEW: 'VIEW',
    DATABASE: 'DATABASE',
    PROJECT: 'PROJECT'
};

export const NOTIFICATION_TYPES = {
    IMPORT: 'IMPORT'
};

export const WEB_COMPONENT_STATUS = {
    LANDING_PAGE: '7b4wc1bzl7lx',
    WEB_APPLICATION: '9k39d2chh7yv',
    API_REQUEST: 'mffvw5pvj3hh'
};

export const API_REQUEST_STATUS = {
    DEGRADED_PERFORMANCE: 'degraded_performance',
    OPERATIONAL: 'operational',
    PARTIAL_OUTAGE: 'partial_outage',
    MAJOR_OUTAGE: 'major_outage',
    UNDER_MAINTENANCE: 'under_maintenance'
};

export const API_REQUEST_STATUS_LABEL = {
    degraded_performance: 'Degraded performance',
    operational: i18n.t('operational'),
    partial_outage: 'Partial outage',
    major_outage: 'Major outage',
    under_maintenance: 'Under maintenance'
};

export const RECORD_IDENTIFIER_TYPE = {
    pathTagRecordId: 'pathTagRecordId',
    recordId: 'recordId'
};

export const MAINTAIN_TYPES = {
    MAINTAIN: 'MAINTAIN',
    UNSTABLE: 'UNSTABLE'
};

export const NOTIFICATION_CENTER_READ_STATE_TYPE = {
    ALL: 'all',
    UNREAD: 'unread',
    READ: 'read'
};

export const NOTIFICATION_CENTER_TABS = [
    { key: 'direct', label: i18n.t('direct') },
    { key: 'system', label: i18n.t('system') }
];

export const NOTIFICATION_CENTER_MESSAGE_TYPE_KEY = {
    TICKET: 'ticket'
};

export const SOURCE_TYPE_OPTIONS = {
    GOOGLE_SHEET: 'GOOGLE_SHEET',
    AUTH_0: 'AUTH_0',
    MICROSOFT: 'MICROSOFT',
    FLUTTER: 'FLUTTER',
    GRIDLY: 'GRIDLY',
    MYSQL: 'MYSQL',
    POSTGRES: 'POSTGRES'
};

export const TUNNEL_TYPE_OPTIONS = {
    NO_TUNNEL: 'NO_TUNNEL',
    SSH_KEY_AUTH: 'SSH_KEY_AUTH',
    SSH_PASSWORD_AUTH: 'SSH_PASSWORD_AUTH'
};

export const SOURCE_STATUS = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};

export const SOURCE_OPTIONS = [
    { label: 'Google sheets', icon: () => <GoogleSheetSVG />, value: SOURCE_TYPE_OPTIONS.GOOGLE_SHEET },
    { label: 'MySQL', icon: () => <MySqlSVG />, value: SOURCE_TYPE_OPTIONS.MYSQL },
    { label: 'PostgreSQL', icon: () => <PostgresSVG />, value: SOURCE_TYPE_OPTIONS.POSTGRES }
];

export const TUNNEL_OPTIONS = [
    { label: 'No tunnel', value: TUNNEL_TYPE_OPTIONS.NO_TUNNEL },
    { label: 'SSH Key Authentication', value: TUNNEL_TYPE_OPTIONS.SSH_KEY_AUTH },
    { label: 'Password authentication', value: TUNNEL_TYPE_OPTIONS.SSH_PASSWORD_AUTH }
];

export const REPLICATION_TYPES = {
    STANDARD: 'STANDARD',
    CDC: 'CDC'
};

export const REPLICATION_METHODS_OPTIONS = [
    { label: REPLICATION_TYPES.STANDARD, value: REPLICATION_TYPES.STANDARD },
    { label: 'Logical replication(CDC)', value: REPLICATION_TYPES.CDC }
];

export const REPLICATION_PLUGIN_OPTIONS = [
    { label: 'pgoutput', value: 'pgoutput' },
    { label: 'wal2json', value: 'wal2json' }
];

// eslint-disable-next-line
export const regexSpecialCharacter = /(?:[!-\/:-@\[-`\{-~\xA1-\xA9\xAB\xAC\xAE-\xB1\xB4\xB6-\xB8\xBB\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u037E\u0384\u0385\u0387\u03F6\u0482\u055A-\u055F\u0589\u058A\u058D-\u058F\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0606-\u060F\u061B\u061E\u061F\u066A-\u066D\u06D4\u06DE\u06E9\u06FD\u06FE\u0700-\u070D\u07F6-\u07F9\u07FE\u07FF\u0830-\u083E\u085E\u0964\u0965\u0970\u09F2\u09F3\u09FA\u09FB\u09FD\u0A76\u0AF0\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0C84\u0D4F\u0D79\u0DF4\u0E3F\u0E4F\u0E5A\u0E5B\u0F01-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F85\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FDA\u104A-\u104F\u109E\u109F\u10FB\u1360-\u1368\u1390-\u1399\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DB\u1800-\u180A\u1940\u1944\u1945\u19DE-\u19FF\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B6A\u1B74-\u1B7C\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2010-\u2027\u2030-\u205E\u207A-\u207E\u208A-\u208E\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2775\u2794-\u2B73\u2B76-\u2B95\u2B98-\u2BC8\u2BCA-\u2BFE\u2CE5-\u2CEA\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u303F\u309B\u309C\u30A0\u30FB\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAA77-\uAA79\uAADE\uAADF\uAAF0\uAAF1\uAB5B\uABEB\uFB29\uFBB2-\uFBC1\uFD3E\uFD3F\uFDFC\uFDFD\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD00-\uDD02\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDC77\uDC78\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEC8\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3F]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3F\uDF44\uDF45]|\uD81B[\uDE97-\uDE9A]|\uD82F[\uDC9C\uDC9F]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE8B]|\uD83A[\uDD5E\uDD5F]|\uD83B[\uDCAC\uDCB0\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED4\uDEE0-\uDEEC\uDEF0-\uDEF9\uDF00-\uDF73\uDF80-\uDFD8]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD00-\uDD0B\uDD10-\uDD3E\uDD40-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF\uDE60-\uDE6D])/g;
export const regexZeroWidthSpace = /[\u200B-\u200D\uFEFF]/g;

export const BATCH_STATUS = {
    STARTED: 'Started',
    COMPLETED: 'Completed',
    FAILED: 'Failed'
};

export const DISPATCH_TYPES = {
    GRID: 'GRID',
    ADVANCED: 'ADVANCED'
};

export const SORT_BY_CRITERIA = {
    CREATED_DATE: 'CREATED_DATE',
    LAST_MODIFIED: 'LAST_MODIFIED',
    ALPHABETICAL: 'ALPHABETICAL'
};

export const ADVANCED_SEARCH_STATUS = {
    DRAFT: 0,
    ACTIVE: 1,
    DELETED: 2,
    BLOCKED: 3
};

export const COLOR_TYPES = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
